import { EulerStateManager } from "../EulerStateManager";
import { BaseState } from "../States/BaseState";
import { EventData } from "../EventData";
import { EventDataEvents } from "../Consts";

class NoMoreBets extends BaseState<EulerStateManager> {
  public id = "NoMoreBets"; // A unique identifier for the state

  constructor(stateManager: EulerStateManager) {
    super(stateManager); // Pass the StateManager to the base class
    this.bindEvents();
    this.subscribeToEvents();
  }

  public onEnter(stateManager: EulerStateManager): void {
    this.stateManager = stateManager; // Set the StateManager reference
    super.onEnter(stateManager); // Call the super method
    this.stateManager.onEnterNoMoreBetsState();

    // If we enter this state and the arrival order has already been assigned, we can transition immediately
    if (EventData.getInstance().wasArrivalOrderAssigned()) {
      this.transition();
    }
  }

  private bindEvents() {
    this.transition = this.transition.bind(this);
  }

  private subscribeToEvents() {
    const eventData = EventData.getInstance();
    eventData.subscribeToEvent(
      EventDataEvents.ON_ARRIVAL_ORDER_ASSIGNED,
      this.transition,
    );
  }

  public transition(): void {
    this.stateManager?.changeState(this.stateManager.eulerUpdatePlayingState);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { NoMoreBets };
